import { useSwipeable } from 'react-swipeable';
import React, { useState, useEffect } from 'react';
import { ChevronDown, ChevronLeft, ChevronRight, Mail, MapPin, Github, Linkedin, Instagram, Code, Briefcase, Award, Sparkles, ChevronUp, Send, Code2 } from 'lucide-react';
import { SiHtml5, SiCss3, SiJavascript, SiReact, SiTypescript, SiTailwindcss, SiNodedotjs, SiPython, SiC, SiGit, SiGithub, SiVisualstudiocode, SiPostgresql, SiDocker, SiFigma, SiPostman, SiNpm, SiOracle, SiOpenjdk, SiMongodb } from 'react-icons/si';
import githubImage from './githubV.png';
import oranImage from './oran.png';
import berryImage from './club.png';
import chessImage from './chess.png';
import entp from './entp.png';
import cetic from './cetic.png';
import dawaDz from './dawaDz.png';
import eventOrgImage from './inapi.png';




const projects = [
  {
    id: 6,
    title: "Oran Smart City – Urban Transport",
    category: "Hackathon / Smart City",
    description: "Created a guide app to help Oran residents navigate the city.",
    fullDesc: "Developed an interactive guide app for Oran residents, providing easy access to city locations, services, and points of interest with a simple and intuitive interface.",
    tech: ["JavaScript", "React"],
    github: "https://github.com/yourusername/oran-smart-city-hackathon",
    image: oranImage,
    color: "#4FD1C5"
  },
  {
    id: 10,
    title: "CETIC Fleet Geolocation & Tracking",
    category: "Internship / Fleet Management",
    description: "Created a web application for real-time geolocation and tracking of the company's vehicle fleet.",
    fullDesc: "Designed and developed a comprehensive fleet management system for CETIC. The platform provides real-time GPS tracking, mission order compliance monitoring, and automatic anomaly detection (such as speeding or unauthorized zone deviations) utilizing Haversine and Ray Casting algorithms.",
    tech: [
      "Laravel",
      "React",
      "PostgreSQL",
      "Leaflet.js",
      "Tailwind CSS"
    ],
    github: "Private Repository",
    image: cetic,
    color: "#4FD1C5"
  },
  {
    id: 6,
    title: "DawaDZ – Smart Pharmaceutical Platform",
    category: "Muhandis Hackathon / HealthTech",
    description: "An intelligent platform connecting patients, pharmacies, and suppliers to facilitate seamless access to medication.",
    fullDesc: "Developed an intelligent platform that bridges the gap between patients, pharmacies, and suppliers. DawaDZ enables real-time medication searches, helps localize nearby pharmacies, and significantly reduces stockouts through an optimized, connected network.",
    tech: ["React", "Laravel", "Capacitor", "Next.js", "PostgreSQL"],
    github: "",
    image: dawaDz,
    color: "#4FD1C5"
  },
  {
    id: 6,
    title: "EventOrg Manager",
    category: "Event Management / Dashboard",
    description: "A comprehensive dashboard created to manage event participants, team assignments, and check-ins.",
    fullDesc: "Developed a web-based dashboard for event organizers to seamlessly manage participating teams, track live check-in statuses, organize seating arrangements by blocks, and dynamically search for specific participants across the venue.",
    tech: ["JavaScript", "HTML", "CSS", "NeonDB"],
    github: "https://github.com/EZZERBOUTIABDELHAK/INAPI-event",
    image: eventOrgImage,
    color: "#4FD1C5"
  },
  {
    id: 9,
    title: "Gestion de Matériel (Asset Management)",
    category: "Enterprise Web App / Inventory",
    description: "Built an internal inventory and asset management system to track equipment, employees, and stock transactions.",
    fullDesc: "Developed a comprehensive enterprise web application for managing company physical assets. The system tracks items by serial numbers, manages employee equipment allocations, and records detailed transaction histories. Features a JSF-based graphical user interface and robust mapping to a MySQL database.",
    tech: ["Java", "JavaServer Faces (JSF)", "MySQL", "EJB / JPA"],
    image: entp,
    color: "#2C5282"
  },

  {
    id: 8,
    title: "Berry Club Official Website",
    category: "Web Development ",
    description: "The official website for Berry Club, a student organization focused on entrepreneurship and innovation.",
    fullDesc: "Designed and developed the official website for Berry Club, the premier student organization dedicated to entrepreneurship, innovation, and new technologies. Built a modern, dark-themed interface using React and Framer Motion, featuring smooth scroll animations, interactive project galleries, and a fully responsive layout to showcase the club's mission and events.",
    tech: ["React", "Framer Motion", "JavaScript"],
    github: "https://github.com/EZZERBOUTIABDELHAK/BerryCLub-Website",
    image: berryImage,
    color: "#4FD1C5"
  },
  {

    id: 7,
    title: "Pro Chess Tournament Manager",
    category: "Full-Stack Web App",
    description: "A comprehensive chess tournament management tool featuring a custom Swiss-style pairing algorithm and real-time standings.",
    fullDesc: "Built a full-stack application to streamline offline chess tournaments. It features a robust 5-round Swiss-style pairing algorithm with strict rules to prevent repeat matchups and handle odd-numbered player brackets. The app includes manual player/table entry, dynamic leaderboards, an editable match history for recalculating scores, and seamless data persistence through a Supabase backend.",
    tech: ["React", "Supabase", "JavaScript"],
    github: "https://github.com/EZZERBOUTIABDELHAK/chess-event-",
    image: chessImage,
    color: "#4FD1C5"

  },
  {
    id: 5,
    title: "GitHub Profile Review",
    category: "Web App / API",
    description: "A web app that analyzes GitHub profiles and displays key stats.",
    fullDesc: "Built a web application that fetches GitHub user data via the GitHub API, showing repositories, followers, contributions, and key stats. Users can enter any GitHub username and instantly see an organized profile overview. Focused on clean UI, responsive design, and real-time data fetching.",
    tech: ["JavaScript", "API Integration"],
    github: "https://github.com/EZZERBOUTIABDELHAK/GitHub-Profile-Explorer",
    image: githubImage,
    color: "#4FD1C5"
  }
];

const education = [
  {
    year: '2024 — Present',
    title: 'Second year Engineering and Management of Information Systems',
    institution: 'National Polytechnic School of Oran — Maurice Audin, Oran'
  },
  {
    year: '2022 — 2024',
    title: 'Preparatory Classes in Science and Technology',
    institution: 'National Polytechnic School of Oran — Maurice Audin, Oran'
  }
];

const experiences = [
  {
    year: 'May 2025',
    title: 'Immersion Internship',
    institution: 'CERIST Algiers'
  },
  {
    year: 'April 2025',
    title: 'Participation in the InnoVerse Hackathon',
    institution: 'ESGEE Oran',
    description: 'Development of solutions for a smart city.'
  },
  {
    year: 'January 2025',
    title: 'Immersion Internship',
    institution: 'Sonelgaz Algiers'
  }
];

const skillSlides = [
  {
    title: 'Technical Skills',
    icon: Code,
    skills: [
      'Front-End Development: HTML5, CSS3, JavaScript',
      'Modern Frameworks: React.js, Redux, component-based architecture',
      'Back-End Basics: Java, Python, SQL, REST APIs integration',
      'Performance Optimization: Efficient code, fast-loading applications'
    ]
  },
  {
    title: 'Development Skills',
    icon: Award,
    skills: [
      'Clean & Maintainable Code: Following best practices and design patterns',
      'Problem-Solving & Debugging: Identifying and fixing bugs quickly',
      'Algorithmic Thinking: Writing efficient and optimized logic',
      'UI/UX Awareness: Building intuitive and visually appealing interfaces'
    ]
  },
  {
    title: 'Soft Skills',
    icon: Briefcase,
    skills: [
      'Teamwork & Agile Collaboration: Working effectively in a development team',
      'Continuous Learning: Keeping up with the latest web technologies',
      'Project Management Basics: Planning, organizing, and delivering on time'
    ]
  }
];

const stats = [
  { icon: Code, value: '15+', label: 'Projects Completed' },
  { icon: Briefcase, value: '4', label: 'Internships & Experiences' },
  { icon: Award, value: '4', label: 'Hackathon' }
];

const styles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  body {
 font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: <weight>;
  font-style: normal;
      background: #0a1628;
    color: #fff;
    overflow-x: hidden;
  }

@media (max-width: 768px) {
    .desktop-menu { display: none !important; }
    .mobile-menu-btn { display: block !important; }
    .nav-arrows { display: none !important; }
  }
  @media (max-width: 768px) {
    @keyframes scrollLeft {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    @keyframes scrollRight {
      0% { transform: translateX(-50%); }
      100% { transform: translateX(0); }
    }
    .tech-icon-card {
      min-width: 90px !important;
      padding: 15px !important;
      gap: 8px !important;
    }
    .tech-icon-card > div:first-child {
      width: 36px !important;
      height: 36px !important;
      font-size: 36px !important;
    }
    .tech-icon-card span {
      font-size: 12px !important;
    }
    .tech-blur-left, .tech-blur-right {
      width: 20px !important;
    }
  }
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
  }
  @keyframes scrollLeft {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
  @keyframes scrollRight {
    0% { transform: translateX(-50%); }
    100% { transform: translateX(0); }
}
  .fade-in {
    animation: fadeInUp 0.8s ease-out forwards;
    opacity: 0;
  }
  .delay-1 { animation-delay: 0.2s; }
  .delay-2 { animation-delay: 0.4s; }
  .delay-3 { animation-delay: 0.6s; }
  .project-modal::-webkit-scrollbar { display: none; }
  .project-modal { scrollbar-width: none; -ms-overflow-style: none; }
  .floating {
    animation: float 6s ease-in-out infinite;
  }
  
  .contact-form-input, .contact-form-textarea {
    width: 100%;
    background-color: rgba(15, 23, 42, 0.8);
    border: 2px solid rgba(79, 209, 197, 0.3);
    color: #fff;
    padding: 18px 20px;
    border-radius: 12px;
    font-size: 16px;
    font-family: 'Inter', sans-serif;
    transition: all 0.3s;
  }
  
  .contact-form-input::placeholder, .contact-form-textarea::placeholder {
    color: #94a3b8;
  }
  
  .contact-form-input:focus, .contact-form-textarea:focus {
    outline: none;
    border-color: #4FD1C5;
    box-shadow: 0 0 15px rgba(79, 209, 197, 0.3);
  }
  
  .contact-form-textarea {
    min-height: 150px;
    resize: vertical;
  }
    
`;

const App = () => {
  const [currentProject, setCurrentProject] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const [activeProject, setActiveProject] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const [educationOpen, setEducationOpen] = useState(true);
  const [experienceOpen, setExperienceOpen] = useState(false);

  const [currentSkillSlide, setCurrentSkillSlide] = useState(0);

  const [formName, setFormName] = useState("");
  const [formEmail, setFormEmail] = useState("");
  const [formSubject, setFormSubject] = useState("");
  const [formMessage, setFormMessage] = useState("");
  const [formStatus, setFormStatus] = useState(null);

  const nextProject = () => setCurrentProject((prev) => (prev + 1) % projects.length);
  const prevProject = () => setCurrentProject((prev) => (prev - 1 + projects.length) % projects.length);

  const nextSkillSlide = () => setCurrentSkillSlide((prev) => (prev + 1) % skillSlides.length);
  const prevSkillSlide = () => setCurrentSkillSlide((prev) => (prev - 1 + skillSlides.length) % skillSlides.length);

  const projectSwipeHandlers = useSwipeable({
    onSwipedLeft: () => nextProject(),
    onSwipedRight: () => prevProject(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const skillSwipeHandlers = useSwipeable({
    onSwipedLeft: () => nextSkillSlide(),
    onSwipedRight: () => prevSkillSlide(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  const TechIcon = ({ name, color, icon: Icon }) => (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      minWidth: '120px',
      padding: '20px',
      background: 'rgba(15, 23, 42, 0.8)',
      borderRadius: '16px',
      border: '1px solid rgba(79, 209, 197, 0.2)',
      transition: 'all 0.3s',
      flexShrink: 0,
      cursor: 'default'
    }}
      className="tech-icon-card"
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.borderColor = color;
        e.currentTarget.style.boxShadow = `0 10px 30px ${color}40`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.borderColor = 'rgba(79, 209, 197, 0.2)';
        e.currentTarget.style.boxShadow = 'none';
      }}
    >
      <div style={{
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: color,
        fontSize: '48px'
      }}>
        <Icon />
      </div>
      <span style={{
        fontSize: '14px',
        fontWeight: '600',
        color: '#cbd5e1',
        textAlign: 'center',
        whiteSpace: 'nowrap'
      }}>
        {name}
      </span>
    </div>
  );


  useEffect(() => {

    const handleScroll = () => {
      const sections = ['home', 'about', 'resume', 'skills', 'projects', 'contact'];
      const scrollPosition = window.scrollY + window.innerHeight / 3;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  useEffect(() => {
    if (activeProject) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [activeProject]);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus(null);

    const googleFormUrl = "https://docs.google.com/forms/u/0/d/15SkB9tbnWgg2TlaLBz3Fyy7Ecnq5hP7Ej6xduieK4i0/formResponse";


    const entryIdName = "entry.780408624";
    const entryIdEmail = "entry.1028410895";
    const entryIdSubject = "entry.1651088280";
    const entryIdMessage = "entry.1266869519";

    const formData = new FormData();
    formData.append(entryIdName, formName);
    formData.append(entryIdEmail, formEmail);
    formData.append(entryIdSubject, formSubject);
    formData.append(entryIdMessage, formMessage);

    try {

      await fetch(googleFormUrl, {
        method: "POST",
        mode: "no-cors",
        body: formData,
      });

      setFormStatus("success");
      setFormName("");
      setFormEmail("");
      setFormSubject("");
      setFormMessage("");

      setTimeout(() => setFormStatus(null), 5000);
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormStatus("error");

      setTimeout(() => setFormStatus(null), 5000);
    }
  };


  return (
    <div>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Momo+Signature&family=Roboto:ital,wght@0,100..900;1,100..900&family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap" rel="stylesheet" />
      <style>{styles}</style>



      {/* Navigation */}
      <nav style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '15px 50px',
        background: 'rgba(10, 22, 40, 0.95)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid rgba(79, 209, 197, 0.1)',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '10px',
            background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px'
          }}>
            AE
          </div>
          <span style={{
            fontSize: '20px',
            fontWeight: 'bold',
            background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>

          </span>
        </div>

        <div style={{ display: 'flex', gap: '40px' }} className="desktop-menu">
          {['home', 'about', 'resume', 'skills', 'projects', 'contact'].map((section) => (
            <button
              key={section}
              onClick={() => scrollToSection(section)}
              style={{
                background: 'none',
                border: 'none',
                color: activeSection === section ? '#4FD1C5' : '#94a3b8',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '500',
                textTransform: 'capitalize',
                position: 'relative',
                padding: '5px 0',
                transition: 'color 0.3s'
              }}
            >

              {section === 'resume' ? 'Resume' : section === 'about' ? 'About' : section}
              {activeSection === section && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '2px',
                  background: 'linear-gradient(90deg, #4FD1C5, #38B2AC)'
                }} />
              )}
            </button>
          ))}
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="mobile-menu-btn"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          style={{
            display: 'none',
            background: '#0a1628',
            border: '2px solid rgba(79, 209, 197, 0.3)',
            borderRadius: '8px',
            color: '#4FD1C5',
            cursor: 'pointer',
            fontSize: '28px',
            padding: '8px 12px'
          }}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <>
          <div
            onClick={() => setMenuOpen(false)}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(10, 22, 40, 0.8)',
              backdropFilter: 'blur(12px)',
              zIndex: 998
            }}
          />

          <div style={{
            position: 'fixed',
            top: '80px',
            right: '20px',
            width: '280px',
            background: '#0a1628',
            border: '2px solid rgba(79, 209, 197, 0.3)',
            borderRadius: '20px',
            padding: '30px 25px',
            zIndex: 1001,
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.8)',
            display: 'flex',
            flexDirection: 'column',
          }}>
            <div>
              {['home', 'about', 'resume', 'skills', 'projects', 'contact'].map((section) => (
                <button
                  key={section}
                  onClick={() => {
                    scrollToSection(section);
                    setMenuOpen(false);
                  }}
                  style={{
                    width: '100%',
                    background: activeSection === section ? 'rgba(79, 209, 197, 0.15)' : 'transparent',
                    border: 'none',
                    color: activeSection === section ? '#4FD1C5' : '#94a3b8',
                    cursor: 'pointer',
                    fontSize: '18px',
                    fontWeight: '600',
                    textTransform: 'capitalize',
                    textAlign: 'left',
                    padding: '14px 20px',
                    borderRadius: '10px',
                    marginBottom: '5px',
                    borderLeft: activeSection === section ? '3px solid #4FD1C5' : '3px solid transparent'
                  }}
                >

                  {section === 'resume' ? 'Resume' : section === 'about' ? 'About' : section}
                </button>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', padding: '20px 0', borderTop: '1px solid rgba(79, 209, 197, 0.2)', marginTop: '20px' }}>
              <a
                href="https://www.linkedin.com/in/abdel-hak-ezzerbouti-5a7487260/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4FD1C5', transition: 'transform 0.3s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <Linkedin size={28} />
              </a>
              <a
                href="https://github.com/EZZERBOUTIABDELHAK"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4FD1C5', transition: 'transform 0.3s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <Github size={28} />
              </a>
              <a
                href="https://www.instagram.com/a2zr_x/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#4FD1C5', transition: 'transform 0.3s' }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <Instagram size={28} />
              </a>
            </div>
          </div>
        </>
      )}


      {/* --- Section Hero --- */}
      <section id="home" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        padding: '0 20px'
      }}>
        <div style={{
          position: 'absolute',
          inset: 0,
          background: 'radial-gradient(circle at 50% 50%, rgba(79, 209, 197, 0.15) 0%, transparent 50%)'
        }} />

        <div className="floating" style={{
          position: 'absolute',
          top: '20%',
          left: '10%',
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(79, 209, 197, 0.2) 0%, transparent 70%)',
          filter: 'blur(40px)'
        }} />
        <div className="floating" style={{
          position: 'absolute',
          bottom: '20%',
          right: '10%',
          width: '150px',
          height: '150px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(56, 178, 172, 0.2) 0%, transparent 70%)',
          filter: 'blur(40px)',
          animationDelay: '2s'
        }} />

        <div className="fade-in" style={{
          textAlign: 'center',
          maxWidth: '1200px',
          position: 'relative',
          zIndex: 1
        }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '10px',
            padding: '10px 20px',
            background: 'rgba(79, 209, 197, 0.1)',
            border: '1px solid rgba(79, 209, 197, 0.3)',
            borderRadius: '50px',
            marginBottom: '30px',
            fontSize: '14px',
            color: '#4FD1C5',
            fontWeight: '600'
          }}>
            <Sparkles size={16} />

            Welcome to my portfolio
          </div>

          <h1 style={{
            fontSize: 'clamp(48px, 8vw, 80px)',
            fontWeight: '900',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            letterSpacing: '-2px',
            lineHeight: '1.1'
          }}>
            Abdel Hak Ezzerbouti
          </h1>

          <p className="fade-in delay-1" style={{
            fontSize: 'clamp(18px, 2vw, 24px)',
            maxWidth: '800px',
            margin: '0 auto 40px',
            color: '#cbd5e1',
            lineHeight: '1.6',
            fontWeight: '500'
          }}>

            Web Developer & Information Systems Engineering Student
          </p>

          <div className="fade-in delay-3" style={{
            display: 'flex',
            gap: '20px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <button
              onClick={() => scrollToSection('projects')}
              style={{
                padding: '18px 40px',
                fontSize: '16px',
                fontWeight: '600',
                background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
                border: 'none',
                borderRadius: '50px',
                color: '#fff',
                cursor: 'pointer',
                boxShadow: '0 10px 40px rgba(79, 209, 197, 0.3)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'transform 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >

              View My Projects
              <ChevronDown size={20} />
            </button>

            <button
              onClick={() => scrollToSection('contact')}
              style={{
                padding: '18px 40px',
                fontSize: '16px',
                fontWeight: '600',
                background: 'transparent',
                border: '2px solid #4FD1C5',
                borderRadius: '50px',
                color: '#4FD1C5',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >

              Contact Me
            </button>
          </div>
        </div>
      </section>

      {/* --- Section About --- */}
      <section id="about" style={{
        padding: '100px 20px',
        background: 'rgba(15, 23, 42, 0.5)',
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        <h2 style={{
          fontSize: 'clamp(40px, 5vw, 64px)',
          textAlign: 'center',
          marginBottom: '60px',
          background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: '700'
        }}>

          About Me
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '30px',
          marginBottom: '60px'
        }}>
          {stats.map((stat, idx) => (
            <div key={idx} style={{
              background: 'rgba(79, 209, 197, 0.05)',
              border: '1px solid rgba(79, 209, 197, 0.2)',
              borderRadius: '20px',
              padding: '40px 30px',
              textAlign: 'center',
              transition: 'all 0.3s'
            }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(79, 209, 197, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.background = 'rgba(79, 209, 197, 0.05)';
                e.currentTarget.style.boxShadow = 'none';
              }}
            >
              <stat.icon size={40} color="#4FD1C5" style={{ marginBottom: '20px' }} />
              <div style={{
                fontSize: '48px',
                fontWeight: '800',
                color: '#4FD1C5',
                marginBottom: '10px'
              }}>
                {stat.value}
              </div>
              <div style={{
                fontSize: '16px',
                color: '#94a3b8',
                fontWeight: '500'
              }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div style={{
          background: 'rgba(15, 23, 42, 0.5)',
          border: '1px solid rgba(79, 209, 197, 0.2)',
          borderRadius: '20px',
          padding: '50px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '18px',
            lineHeight: '1.8',
            color: '#cbd5e1',
            maxWidth: '900px',
            margin: '0 auto'
          }}>

            I’m Abdel Hak, a curious mind who loves turning ideas
            into something real, structured, and meaningful.
            I’m driven by problem-solving, clean design,
            and the satisfaction of building things that
            simply work. I see every project as a chance
            to learn, to improve, and to push my limits.
            Teamwork, creativity, and precision define
            the way I approach challenges. I’m constantly
            exploring new concepts, refining my craft,
            and shaping my path as a creator who values
            clarity, efficiency, and impact.
          </p>
        </div>
      </section>

      {/* --- Section Resume --- */}
      <section id="resume" style={{
        padding: '100px 20px',
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        <h2 style={{
          fontSize: 'clamp(40px, 5vw, 64px)',
          textAlign: 'center',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: '700'
        }}>

          My Resume
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '18px',
          color: '#cbd5e1',
          maxWidth: '800px',
          margin: '0 auto 60px'
        }}>

          My education and professional experiences
        </p>

        <div style={{ marginBottom: '60px' }}>
          <button
            onClick={() => {
              setEducationOpen(prev => !prev);
              setExperienceOpen(false);
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#4FD1C5',
              fontSize: '28px',
              marginBottom: '30px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            <Award size={28} />

            Education
            <span style={{ marginLeft: 'auto', transition: 'transform 0.3s', transform: educationOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <ChevronDown size={28} />
            </span>
          </button>

          {educationOpen && (
            <div style={{ position: 'relative', paddingLeft: '3rem' }}>
              <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '2px',
                background: 'linear-gradient(180deg, #4FD1C5, #38B2AC)'
              }} />

              {education.map((item, idx) => (
                <div key={idx} style={{ position: 'relative', marginBottom: '3rem' }}>
                  <div style={{
                    position: 'absolute',
                    left: '-3.5rem',
                    top: 0,
                    width: '16px',
                    height: '16px',
                    background: 'linear-gradient(135deg, #4FD1C5, #38B2AC)',
                    borderRadius: '50%',
                    border: '4px solid #0a1628',
                    boxShadow: '0 0 0 4px rgba(79, 209, 197, 0.2)'
                  }} />

                  <div style={{
                    background: 'rgba(15, 23, 42, 0.5)',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    borderLeft: '3px solid #4FD1C5',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(79, 209, 197, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <span style={{
                      display: 'inline-block',
                      padding: '0.25rem 0.75rem',
                      background: 'rgba(79, 209, 197, 0.2)',
                      color: '#4FD1C5',
                      borderRadius: '20px',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      marginBottom: '0.5rem'
                    }}>
                      {item.year}
                    </span>
                    <h4 style={{ fontSize: '1.25rem', marginBottom: '0.5rem', color: '#fff' }}>
                      {item.title}
                    </h4>
                    <p style={{ color: '#cbd5e1' }}>{item.institution}</p>
                    {item.description && (
                      <p style={{ marginTop: '0.5rem', fontStyle: 'italic', color: '#94a3b8' }}>
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div>
          <button
            onClick={() => {
              setExperienceOpen(prev => !prev);
              setEducationOpen(false);
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#38B2AC',
              fontSize: '28px',
              marginBottom: '30px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: 'pointer',
              width: '100%'
            }}
          >
            <Briefcase size={28} />
            Experiences
            <span style={{ marginLeft: 'auto', transition: 'transform 0.3s', transform: experienceOpen ? 'rotate(180deg)' : 'rotate(0deg)' }}>
              <ChevronDown size={28} />
            </span>
          </button>

          {experienceOpen && (
            <div style={{ position: 'relative', paddingLeft: '3rem' }}>
              <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                bottom: 0,
                width: '2px',
                background: 'linear-gradient(180deg, #4FD1C5, #38B2AC)'
              }} />

              {experiences.map((item, idx) => (
                <div key={idx} style={{ position: 'relative', marginBottom: '3rem' }}>
                  <div style={{
                    position: 'absolute',
                    left: '-3.5rem',
                    top: 0,
                    width: '16px',
                    height: '16px',
                    background: 'linear-gradient(135deg, #4FD1C5, #38B2AC)',
                    borderRadius: '50%',
                    border: '4px solid #0a1628',
                    boxShadow: '0 0 0 4px rgba(79, 209, 197, 0.2)'
                  }} />

                  <div style={{
                    background: 'rgba(15, 23, 42, 0.5)',
                    padding: '1.5rem',
                    borderRadius: '12px',
                    borderLeft: '3px solid #4FD1C5',
                    transition: 'all 0.3s'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateX(5px)';
                      e.currentTarget.style.boxShadow = '0 10px 30px rgba(79, 209, 197, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateX(0)';
                      e.currentTarget.style.boxShadow = 'none';
                    }}
                  >
                    <span style={{
                      display: 'inline-block',
                      padding: '0.25rem 0.75rem',
                      background: 'rgba(79, 209, 197, 0.2)',
                      color: '#4FD1C5',
                      borderRadius: '20px',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      marginBottom: '0.5rem'
                    }}>
                      {item.year}
                    </span>
                    <h4 style={{ fontSize: '1.25rem', marginBottom: '0.5rem', color: '#fff' }}>
                      {item.title}
                    </h4>
                    <p style={{ color: '#cbd5e1' }}>{item.institution}</p>
                    {item.description && (
                      <p style={{ marginTop: '0.5rem', fontStyle: 'italic', color: '#94a3b8' }}>
                        {item.description}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* --- Section Skills --- */}
      <section id="skills" style={{
        padding: '100px 20px',
        background: 'rgba(15, 23, 42, 0.5)',
        maxWidth: '1200px',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
        <h2 style={{
          fontSize: 'clamp(40px, 5vw, 64px)',
          textAlign: 'center',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: '700'
        }}>
          Skills
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '18px',
          color: '#cbd5e1',
          maxWidth: '800px',
          margin: '0 auto 60px'
        }}>
          My technical skills and tools
        </p>

        <div style={{
          position: 'relative',
          maxWidth: '900px',
          margin: '0 auto'
        }}>

          <div
            {...skillSwipeHandlers}
            style={{
              background: 'rgba(15, 23, 42, 0.8)',
              border: '1px solid rgba(79, 209, 197, 0.2)',
              borderRadius: '20px',
              padding: '40px',
              minHeight: '400px',
              boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
              transition: 'all 0.3s'
            }}>

            <h3 style={{
              fontSize: '28px',
              marginBottom: '30px',
              color: '#4FD1C5',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}>
              {React.createElement(skillSlides[currentSkillSlide].icon, { size: 28 })}
              {skillSlides[currentSkillSlide].title}
            </h3>

            <ul style={{
              listStyle: 'none',
              paddingLeft: '10px'
            }}>
              {skillSlides[currentSkillSlide].skills.map((skill, idx) => (
                <li key={idx} style={{
                  fontSize: '18px',
                  color: '#cbd5e1',
                  marginBottom: '18px',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '15px',
                  lineHeight: '1.5'
                }}>
                  <ChevronRight size={18} color="#4FD1C5" style={{ flexShrink: 0, marginTop: '5px' }} />
                  <span>{skill}</span>
                </li>
              ))}
            </ul>
          </div>

          <button
            onClick={prevSkillSlide}
            className="nav-arrows"
            aria-label="Previous skill"
            style={{
              position: 'absolute',
              left: '-70px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'rgba(79, 209, 197, 0.2)',
              border: '1px solid rgba(79, 209, 197, 0.5)',
              color: '#4FD1C5',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
              e.currentTarget.style.color = '#fff';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(79, 209, 197, 0.2)';
              e.currentTarget.style.color = '#4FD1C5';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            }}
          >
            <ChevronLeft size={24} />
          </button>

          <button
            onClick={nextSkillSlide}
            className="nav-arrows"
            aria-label="Next skill"
            style={{
              position: 'absolute',
              right: '-70px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'rgba(79, 209, 197, 0.2)',
              border: '1px solid rgba(79, 209, 197, 0.5)',
              color: '#4FD1C5',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
              e.currentTarget.style.color = '#fff';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(79, 209, 197, 0.2)';
              e.currentTarget.style.color = '#4FD1C5';
              e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
            }}
          >
            <ChevronRight size={24} />
          </button>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            marginTop: '30px'
          }}>
            {skillSlides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSkillSlide(idx)}
                aria-label={`Go to skill ${idx + 1}`}
                style={{
                  width: currentSkillSlide === idx ? '40px' : '10px',
                  height: '10px',
                  borderRadius: '5px',
                  background: currentSkillSlide === idx ? 'linear-gradient(90deg, #4FD1C5, #38B2AC)' : 'rgba(79, 209, 197, 0.3)',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              />
            ))}
          </div>

        </div>
      </section>
      {/* --- Section Technologies --- */}
      <section style={{
        padding: '100px 20px',
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden',
        background: 'rgba(15, 23, 42, 0.5)'
      }}>
        <h2 style={{
          fontSize: 'clamp(40px, 5vw, 64px)',
          textAlign: 'center',
          marginBottom: '20px',
          background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          fontWeight: '700'
        }}>
          Technologies & Tools
        </h2>
        <p style={{
          textAlign: 'center',
          fontSize: '18px',
          color: '#cbd5e1',
          maxWidth: '800px',
          margin: '0 auto 60px'
        }}>
          The technologies I work with daily
        </p>

        <div style={{
          position: 'relative',
          padding: '20px 0',
          maxWidth: '1400px',
          margin: '0 auto',
          overflow: 'hidden'
        }}>

          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: '100px',
            background: 'linear-gradient(90deg, rgba(15, 23, 42, 1) 0%, transparent 100%)',
            zIndex: 2,
          }} />


          <div style={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '100px',
            background: 'linear-gradient(270deg, rgba(15, 23, 42, 1) 0%, transparent 100%)',
            zIndex: 2,
          }} />
          {/* Première ligne - défilement droite vers gauche */}
          <div style={{
            display: 'flex',
            gap: '40px',
            marginBottom: '40px',
            animation: 'scrollLeft 40s linear infinite',
            width: 'fit-content'
          }}>
            {/* Dupliquer pour effet seamless */}
            {[...Array(2)].map((_, setIndex) => (
              <React.Fragment key={setIndex}>
                <TechIcon name="HTML5" color="#E34F26" icon={SiHtml5} />
                <TechIcon name="CSS3" color="#1572B6" icon={SiCss3} />
                <TechIcon name="JavaScript" color="#F7DF1E" icon={SiJavascript} />
                <TechIcon name="React" color="#61DAFB" icon={SiReact} />
                <TechIcon name="TypeScript" color="#3178C6" icon={SiTypescript} />
                <TechIcon name="Tailwind" color="#06B6D4" icon={SiTailwindcss} />
                <TechIcon name="Node.js" color="#339933" icon={SiNodedotjs} />
                <TechIcon name="Python" color="#3776AB" icon={SiPython} />

              </React.Fragment>
            ))}
          </div>

          {/* Deuxième ligne - défilement gauche vers droite */}
          <div style={{
            display: 'flex',
            gap: '40px',
            animation: 'scrollRight 40s linear infinite',
            width: 'fit-content'
          }}>
            {/* Dupliquer pour effet seamless */}
            {[...Array(2)].map((_, setIndex) => (
              <React.Fragment key={setIndex}>
                <TechIcon name="PostgreSQL" color="#4169E1" icon={SiPostgresql} />
                <TechIcon name="Docker" color="#2496ED" icon={SiDocker} />
                <TechIcon name="Figma" color="#F24E1E" icon={SiFigma} />
                <TechIcon name="Java" color="#007396" icon={SiOpenjdk} />
                <TechIcon name="Git" color="#F05032" icon={SiGit} />
                <TechIcon name="GitHub" color="#181717" icon={SiGithub} />
                <TechIcon name="Oracle" color="#F80000" icon={SiOracle} />
                <TechIcon name="MongoDB" color="#47A248" icon={SiMongodb} />
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* --- Section Projects --- */}
      <section id="projects" style={{
        padding: '100px 20px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: 'clamp(40px, 5vw, 64px)',
            textAlign: 'center',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: '700'
          }}>
            My Projects
          </h2>
          <p style={{
            textAlign: 'center',
            fontSize: '18px',
            color: '#cbd5e1',
            maxWidth: '800px',
            margin: '0 auto 60px'
          }}>
            Discover my creative and technological projects
          </p>

          <div style={{ position: 'relative', maxWidth: '800px', margin: '0 auto' }}>
            <div
              {...projectSwipeHandlers}
              style={{
                background: 'rgba(79, 209, 197, 0.05)',
                borderRadius: '20px',
                overflow: 'hidden',
                border: '1px solid rgba(79, 209, 197, 0.2)',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 30px 70px rgba(79, 209, 197, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.3)';
              }}
            >
              <div style={{
                height: '300px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img
                  src={projects[currentProject].image}
                  alt={projects[currentProject].title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(180deg, transparent 0%, rgba(10, 22, 40, 0.7) 100%)'
                }} />
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  padding: '10px 20px',
                  background: 'rgba(79, 209, 197, 0.7)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '50px',
                  fontSize: '14px',
                  color: '#fff',
                  fontWeight: '700'
                }}>
                  {projects[currentProject].category}
                </div>
              </div>
              <div style={{ padding: '40px', minHeight: '320px' }}>
                <h3 style={{
                  fontSize: '32px',
                  marginBottom: '15px',
                  color: '#4FD1C5',
                  fontWeight: '700'
                }}>
                  {projects[currentProject].title}
                </h3>
                <p style={{
                  fontSize: '18px',
                  lineHeight: '1.8',
                  color: '#cbd5e1',
                  marginBottom: '20px'
                }}>
                  {projects[currentProject].description}
                </p>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '25px', flexWrap: 'wrap' }}>
                  {projects[currentProject].tech.map((tech, i) => (
                    <span key={i} style={{
                      padding: '8px 16px',
                      background: 'rgba(79, 209, 197, 0.2)',
                      color: '#4FD1C5',
                      borderRadius: '20px',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}>
                      {tech}
                    </span>
                  ))}
                </div>
                <button
                  onClick={() => setActiveProject(projects[currentProject])}
                  style={{
                    padding: '12px 30px',
                    background: 'transparent',
                    border: '2px solid #4FD1C5',
                    color: '#4FD1C5',
                    borderRadius: '50px',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.borderColor = 'transparent';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#4FD1C5';
                    e.currentTarget.style.borderColor = '#4FD1C5';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  View Details
                </button>
              </div>
            </div>

            <button
              onClick={prevProject}
              className="nav-arrows"
              aria-label="Previous project"
              style={{
                position: 'absolute',
                left: '-70px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'rgba(79, 209, 197, 0.2)',
                border: '1px solid rgba(79, 209, 197, 0.5)',
                color: '#4FD1C5',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(79, 209, 197, 0.2)';
                e.currentTarget.style.color = '#4FD1C5';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              <ChevronLeft size={24} />
            </button>

            <button
              onClick={nextProject}
              className="nav-arrows"
              aria-label="Next project"
              style={{
                position: 'absolute',
                right: '-70px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                background: 'rgba(79, 209, 197, 0.2)',
                border: '1px solid rgba(79, 209, 197, 0.5)',
                color: '#4FD1C5',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                e.currentTarget.style.color = '#fff';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(79, 209, 197, 0.2)';
                e.currentTarget.style.color = '#4FD1C5';
                e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
              }}
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '10px',
            marginTop: '40px'
          }}>
            {projects.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentProject(idx)}
                aria-label={`Go to project ${idx + 1}`}
                style={{
                  width: currentProject === idx ? '40px' : '10px',
                  height: '10px',
                  borderRadius: '5px',
                  background: currentProject === idx ? 'linear-gradient(90deg, #4FD1C5, #38B2AC)' : 'rgba(79, 209, 197, 0.3)',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'all 0.3s'
                }}
              />
            ))}
          </div>
        </div>


      </section>
      {/* --- Section Contact --- */}
      <section id="contact" style={{
        padding: '100px 20px',
        background: 'rgba(15, 23, 42, 0.5)',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          <h2 style={{
            fontSize: 'clamp(40px, 5vw, 64px)',
            textAlign: 'center',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: '700'
          }}>
            Contact Me
          </h2>
          <p style={{
            textAlign: 'center',
            fontSize: '18px',
            color: '#cbd5e1',
            maxWidth: '800px',
            margin: '0 auto 60px'
          }}>
            Feel free to contact me for any opportunities or collaboration
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '60px'
          }}>

            {/* Colonne de Gauche (Infos) */}
            <div>
              <div style={{ marginBottom: '40px' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  marginBottom: '20px',
                  padding: '20px',
                  background: 'rgba(79, 209, 197, 0.1)',
                  borderRadius: '12px',
                  border: '1px solid rgba(79, 209, 197, 0.2)',
                  transition: 'all 0.3s'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgba(79, 209, 197, 0.15)';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}
                >
                  <Mail size={24} color="#4FD1C5" />
                  <span style={{ color: '#cbd5e1', fontSize: '16px' }}>abdelhak.ezzerbouti@etu.enp-oran.dz</span>
                </div>
              </div>

              <div style={{
                marginBottom: '30px',
              }}>
                <p style={{
                  fontSize: '18px',
                  color: '#94a3b8',
                  marginBottom: '20px',
                  fontWeight: '600'
                }}>
                  Follow me on social media
                </p>
              </div>

              <div style={{ display: 'flex', gap: '20px', justifyContent: 'flex-start' }}>
                <a
                  href="https://www.linkedin.com/in/abdel-hak-ezzerbouti-5a7487260/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'rgba(79, 209, 197, 0.1)',
                    border: '1px solid rgba(79, 209, 197, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4FD1C5',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                    e.currentTarget.style.color = '#4FD1C5';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Linkedin size={24} />
                </a>
                <a
                  href="https://github.com/EZZERBOUTIABDELHAK"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'rgba(79, 209, 197, 0.1)',
                    border: '1px solid rgba(79, 209, 197, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4FD1C5',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                    e.currentTarget.style.color = '#4FD1C5';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Github size={24} />
                </a>
                <a
                  href="https://www.instagram.com/a2zr_x/"
                  target="_blank"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    background: 'rgba(79, 209, 197, 0.1)',
                    border: '1px solid rgba(79, 209, 197, 0.3)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#4FD1C5',
                    transition: 'all 0.3s'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.transform = 'scale(1.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'rgba(79, 209, 197, 0.1)';
                    e.currentTarget.style.color = '#4FD1C5';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <Instagram size={24} />
                </a>
              </div>
            </div>

            {/* Colonne de Droite (Formulaire) */}
            <div>
              <form
                onSubmit={handleFormSubmit}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px'
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label htmlFor="name" style={{ color: '#cbd5e1', fontWeight: '500' }}>Name</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Your full name"
                    className="contact-form-input"
                    required
                    value={formName}
                    onChange={(e) => setFormName(e.target.value)}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label htmlFor="email" style={{ color: '#cbd5e1', fontWeight: '500' }}>Email</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Your email"
                    className="contact-form-input"
                    required
                    value={formEmail}
                    onChange={(e) => setFormEmail(e.target.value)}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label htmlFor="subject" style={{ color: '#cbd5e1', fontWeight: '500' }}>Subject</label>
                  <input
                    type="text"
                    id="subject"
                    placeholder="Subject of your message"
                    className="contact-form-input"
                    required
                    value={formSubject}
                    onChange={(e) => setFormSubject(e.target.value)}
                  />
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <label htmlFor="message" style={{ color: '#cbd5e1', fontWeight: '500' }}>Message</label>
                  <textarea
                    id="message"
                    placeholder="Your message..."
                    className="contact-form-textarea"
                    required
                    value={formMessage}
                    onChange={(e) => setFormMessage(e.target.value)}
                  />
                </div>

                {/* --- ADDED FOR GOOGLE FORM (Success/Error Messages) --- */}
                {formStatus === "success" && (
                  <p style={{ color: '#4FD1C5', background: 'rgba(79, 209, 197, 0.1)', padding: '15px', borderRadius: '8px', border: '1px solid rgba(79, 209, 197, 0.3)' }}>
                    Message sent successfully! Thank you.
                  </p>
                )}
                {formStatus === "error" && (
                  <p style={{ color: '#F687B3', background: 'rgba(246, 135, 179, 0.1)', padding: '15px', borderRadius: '8px', border: '1px solid rgba(246, 135, 179, 0.3)' }}>
                    Something went wrong. Please try again.
                  </p>
                )}

                <button
                  type="submit"
                  style={{
                    padding: '18px 40px',
                    fontSize: '16px',
                    fontWeight: '600',
                    background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
                    border: 'none',
                    borderRadius: '50px',
                    color: '#fff',
                    cursor: 'pointer',
                    boxShadow: '0 10px 40px rgba(79, 209, 197, 0.3)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '10px',
                    transition: 'all 0.3s',
                    marginTop: '10px'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(79, 209, 197, 0.4)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 10px 40px rgba(79, 209, 197, 0.3)';
                  }}
                >
                  Send Message
                  <Send size={18} />
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>

      {/* --- Footer --- */}
      <footer style={{
        padding: '40px 20px',
        textAlign: 'center',
        background: '#0a1628',
        borderTop: '1px solid rgba(79, 209, 197, 0.1)',
        color: '#94a3b8',
        position: 'relative',
        zIndex: 1
      }}>
        <p>&copy; {new Date().getFullYear()} Abdel Hak Ezzerbouti — Precision. Passion. Performance.</p>
      </footer>
      {/* Project Modal */}
      {activeProject && (
        <div
          onClick={() => setActiveProject(null)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(10, 22, 40, 0.95)',
            backdropFilter: 'blur(10px)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            overflowY: 'auto',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '700px',
              width: '90%',
              maxHeight: '80vh',
              background: 'linear-gradient(135deg, rgba(15, 30, 50, 0.95) 0%, rgba(10, 22, 40, 0.95) 100%)',
              borderRadius: '24px',
              border: '2px solid #4FD1C5',
              boxShadow: '0 20px 60px rgba(79, 209, 197, 0.3)',
              overflow: 'hidden',

            }}
          >
            <button
              onClick={() => setActiveProject(null)}
              aria-label="Close modal"
              style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                width: '44px',
                height: '44px',
                borderRadius: '50%',
                background: 'rgba(10, 22, 40, 0.9)',
                border: '2px solid #4FD1C5',
                color: '#4FD1C5',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
                zIndex: 10,
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'rotate(90deg) scale(1.1)';
                e.currentTarget.style.background = 'linear-gradient(135deg, #4FD1C5, #38B2AC)';
                e.currentTarget.style.color = '#fff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'rotate(0deg) scale(1)';
                e.currentTarget.style.background = 'rgba(10, 22, 40, 0.9)';
                e.currentTarget.style.color = '#4FD1C5';
              }}
            >
              ✕
            </button>

            <div style={{
              maxHeight: '80vh',
              overflowY: 'auto',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none'
            }}
              className="project-modal"
            >
              <div style={{
                height: '200px',
                position: 'relative',
                overflow: 'hidden'
              }}>
                <img
                  src={activeProject.image}
                  alt={activeProject.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center'
                  }}
                />
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(180deg, transparent 0%, rgba(10, 22, 40, 0.7) 100%)'
                }} />
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  left: '20px',
                  padding: '10px 20px',
                  background: 'rgba(79, 209, 197, 0.7)',
                  backdropFilter: 'blur(10px)',
                  border: '2px solid #4FD1C5',
                  borderRadius: '50px',
                  fontSize: '14px',
                  color: '#fff',
                  fontWeight: '700'
                }}>
                  {activeProject.category}
                </div>
              </div>

              <div style={{ padding: '40px 30px' }}>
                <h3 style={{
                  fontSize: 'clamp(28px, 5vw, 40px)',
                  marginBottom: '20px',
                  background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontWeight: '800',
                  lineHeight: '1.2'
                }}>
                  {activeProject.title}
                </h3>

                <p style={{
                  fontSize: '17px',
                  lineHeight: '1.8',
                  color: '#cbd5e1',
                  marginBottom: '30px'
                }}>
                  {activeProject.fullDesc}
                </p>

                <div style={{ marginBottom: '30px' }}>
                  <h4 style={{
                    fontSize: '14px',
                    color: '#94a3b8',
                    marginBottom: '15px',
                    fontWeight: '700',
                    letterSpacing: '1px',
                    textTransform: 'uppercase'
                  }}>
                    Technologies
                  </h4>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {activeProject.tech.map((tech, i) => (
                      <span
                        key={i}
                        style={{
                          padding: '10px 18px',
                          background: 'rgba(79, 209, 197, 0.2)',
                          border: '1px solid rgba(79, 209, 197, 0.4)',
                          borderRadius: '10px',
                          fontSize: '14px',
                          color: '#4FD1C5',
                          fontWeight: '600'
                        }}
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                <a
                  href={activeProject.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '16px 32px',
                    background: 'linear-gradient(135deg, #4FD1C5 0%, #38B2AC 100%)',
                    color: '#fff',
                    borderRadius: '12px',
                    textDecoration: 'none',
                    fontWeight: '700',
                    fontSize: '16px',
                    transition: 'all 0.3s',
                    boxShadow: '0 4px 20px rgba(79, 209, 197, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(79, 209, 197, 0.6)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 20px rgba(79, 209, 197, 0.4)';
                  }}
                >
                  <Github size={20} />
                  View on GitHub
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
